const DOMAIN = process.env.REACT_APP_DOMAIN;
export let URL_SIGNIN = DOMAIN + '/user/signin';
export let URL_SEND_REGCODE = DOMAIN + '/user/reg_code';
export let URL_SIGNUP = DOMAIN + '/user/signup';
export let URL_LOGIN_STATUS = DOMAIN + '/user/login_status';
export let URL_LOGOUT = DOMAIN + '/user/logout';
export let URL_GET_AURH_URI = DOMAIN + '/wechat/auth_uri';
export let URL_GET_USER_BASEINFO = DOMAIN + '/user/base_info';
// 消息宝
export let URL_GET_WECHAT_TEMPLATE_LIST = DOMAIN + '/template_msg/wechat_template/list';
export let URL_GET_MY_TEMPLATE_LIST = DOMAIN + '/template_msg/my_template/list';
export let URL_SYNC_MY_TEMPLATE_LIST = DOMAIN + '/template_msg/my_template/sync';
export let URL_SYNC_MY_TEMPLATE_PREVIEW = DOMAIN + '/template_msg/preview?msgId=';
export let URL_ADD_MSG_TEMPLATE = DOMAIN + '/template_msg/my_template/add';
export let URL_IS_MSG_TEMPLATE_NULL = DOMAIN + '/template_msg/my_template/isnull';
export let URL_GET_MSG_TEMPLATE_SELECT_LIST = DOMAIN + '/template_msg/my_template/select_list';
export let URL_ADD_TEMPLATE_MSG = DOMAIN + '/template_msg/add';
export let URL_EDIT_TEMPLATE_MSG = DOMAIN + '/template_msg/edit';
export let URL_DELETE_TEMPLATE_MSG = DOMAIN + '/template_msg/delete';
export let URL_GET_TEMPLATE_MSG_LIST = DOMAIN + '/template_msg/list';
export let URL_GET_TEMPLATE_MSG_SELECT_LIST = DOMAIN + '/template_msg/selectlist';
export let URL_SYNC_FANS = DOMAIN + '/fans/sync';
export let URL_SYNC_FANS_STATUS = DOMAIN + '/fans/sync/status';
export let URL_SYNC_FANS_PROGRESS = DOMAIN + '/fans/sync/progress';
export let URL_GET_FANS_LIST = DOMAIN + '/fans/list';
export let URL_SEARCH_FANS = DOMAIN + '/fans/search';
export let URL_ADD_SUBSTAG = DOMAIN + '/substag/add';
export let URL_DELETE_SUBSTAG = DOMAIN + '/substag/delete';
export let URL_RENAME_SUBSTAG = DOMAIN + '/substag/rename';
export let URL_GET_SUBSTAG_LIST = DOMAIN + '/substag/list';
export let URL_ADD_MSG_TEMPLATE_TASK = DOMAIN + '/template_msg/task/add';
export let URL_GET_MSG_TEMPLATE_TASK_LIST = DOMAIN + '/template_msg/task/list';
export let URL_QUERY_MSG_TEMPLATE_TASK_LIST = DOMAIN + '/template_msg/task/query';
export let URL_EXPORT_MSG_TEMPLATE_TASK_LIST = DOMAIN + '/template_msg/task/export';
export let URL_GET_MSG_TEMPLATE_SUB_EXPRIRED = DOMAIN + '/subs/expired';
export let URL_GET_MSG_TEMPLATE_MSG_TASK_TP_MSGLIMIT = DOMAIN + '/template_msg/task/tp_msglimit';
// 列表详情
export let URL_GET_MSG_TEMPLATE_MSG_TASK_DETAIL = DOMAIN + '/template_msg/task/detail';
// 获取新建模板的模板
export let URL_GET_MSG_TEMPLATE_MSG_SYNC = DOMAIN + '/template_msg/my_template/sync';
export let URL_GET_MSG_TEMPLATE_MSG_PREVIEW = DOMAIN + '/template_msg/preview';
// 获取用户头像
export let URL_GET_MSG_SUBS_HEADING = DOMAIN + '/subs/headimg';
export let URL_GET_MSG_UPLOAD_PIC = DOMAIN + '/images/upload_wx';//上传图片
export let URL_CREATE_TEMPLATE_MSG_TASK_ADD = DOMAIN + '/template_msg/task/add';//新建
export let URL_GET_MSG_TEMPLATE_TASK_ACTIVE_LIST = DOMAIN + '/subs/active/list';
export let URL_GET_MSG_TEMPLATE_TASK_ACTIVE_CORPLIST = DOMAIN + '/subs/active/corplist';
export let URL_UPDATE_FAN_TAGS = DOMAIN + '/fans/tags/modify';
export let URL_UPDATE_FAN_REMARK = DOMAIN + '/fans/remark/modify';
export let URL_GET_VERIFY_CODE = DOMAIN + '/user/verifycode?rd=';
export let URL_FP_CHECK_ACCOUNT = DOMAIN + '/findpw/check_account';
export let URL_FP_CHECK_VC = DOMAIN + '/findpw/check_vc';
export let URL_FP_SETPWD = DOMAIN + '/findpw/setpwd';
export let URL_USER_RESETPWD = DOMAIN + '/user/reset_pwd';
export let URL_ADD_TASKPOSTER = DOMAIN + '/taskposter/add';
export let URL_TASKPOSTER_UPLOADIMG = DOMAIN + '/taskposter/uploadimg';
export let URL_MODIFY_TASKPOSTER = DOMAIN + '/taskposter/modify';
export let URL_TASKPOSTER_RANK_QRCODE = DOMAIN + '/taskposter/rank/qrcode?taskposterId=';
export let URL_GET_TASKPOSTER_LIST = DOMAIN + '/taskposter/list';
export let URL_GET_TASKPOSTER_SUBSLIST = DOMAIN + '/taskposter/subslist';
export let URL_GET_TASKPOSTER = DOMAIN + '/taskposter/get';
export let URL_PRECHECK_TASKPOSTER = DOMAIN + '/taskposter/precheck';
export let URL_DELETE_TASKPOSTER = DOMAIN + '/taskposter/delete';
export let URL_CLOSE_TASKPOSTER = DOMAIN + '/taskposter/close';
export let URL_GET_TASKPOSTER_LTM = DOMAIN + '/taskposter/ltm';
export let URL_START_TASKPOSTER = DOMAIN + '/taskposter/start';
export let URL_STAS_TASKPOSTER = DOMAIN + '/taskposter/stas';
export let URL_PROMPTION_COUPONCODE = DOMAIN + '/promption/coupon_code';
export let URL_PROMPTION_STATIS_OLD = DOMAIN + '/promption/statis_old';
export let URL_PROMPTION_LOG_OLD = DOMAIN + '/promption/log_old';
export let URL_PROMPTION_STATIS = DOMAIN + '/promption/statis';
export let URL_PROMPTION_LOG = DOMAIN + '/promption/log';
export let URL_PROMPTION_LOGIN_STATUS = DOMAIN + '/promption/login_status';
export let URL_PROMPTION_SIGNIN_QRCODE = DOMAIN + '/promption/signin_qrcode?qrid=';
export let URL_PROMPTION_SIGNIN_CHECK = DOMAIN + '/promption/signin_check';
export let URL_PROMPTION_LOGOUT = DOMAIN + '/promption/logout';
export let URL_PROMPTION_FXQRCODE = DOMAIN + '/promption/fxqrcode';
export let URL_TASKPOSTER_ACTIVEFANS = DOMAIN + '/taskposter/activefan/list';
export let URL_GET_TASKPOSTER_SELECTLIST = DOMAIN + '/taskposter/selectlist';
export let URL_GET_TASKPOSTER_DETAIL = DOMAIN + '/taskposter/detail';
export let URL_TASKPOSTER_ACTIVEFANS_STAS = DOMAIN + '/taskposter/activefan/stas';
export let URL_TASKPOSTER_ACTIVEFANS_SEARCH = DOMAIN + '/taskposter/activefan/search';
export let URL_UPDATE_TASKPOSTER_ACTIVEFANS_PRIZE = DOMAIN + '/taskposter/activefan/prize';
export let URL_UPDATE_TASKPOSTER_ACTIVEFANS_REMARK = DOMAIN + '/taskposter/activefan/remark';
export let URL_GET_TASKPOSTER_ACTIVEFANS_FORMDATA = DOMAIN + '/taskposter/activefan/formdata';
export let URL_TASKPOSTER_BASESTAS = DOMAIN + '/taskposter/base_stas';
export let URL_TASKPOSTER_STAT_TOTAL = DOMAIN + '/taskposter/stat/total';
export let URL_TASKPOSTER_STAT_PART = DOMAIN + '/taskposter/stat/part';
export let URL_TASKPOSTER_STAT_FANS_PERIOD = DOMAIN + '/taskposter//stats/todaydetail';
export let URL_TASKPOSTER_STAT_FANSLEVELNUM = DOMAIN + '/taskposter/stat/fansLevelNum';
export let URL_TASKPOSTER_STAT_ACTIVITY = DOMAIN + '/taskposter/stat/activity';
export let URL_TASKPOSTER_STAT_CHANNEL = DOMAIN + '/taskposter/stats/channelwords';
export let URL_TASKPOSTER_CHANNEL_SUBS_LIST = DOMAIN + '/taskposter/channel_subs_list';
export let URL_STOP_MSGTASK = DOMAIN + '/template_msg/task/stop';
export let URL_START_MSGTASK = DOMAIN + '/template_msg/task/start';
export let URL_SHARETREASURE_UPLOADMATCHIMG = DOMAIN + '/sharetreasure/upload/matchimg';
export let URL_ADD_SHARETREASURE = DOMAIN + '/sharetreasure/add';
export let URL_MODIFY_SHARETREASURE = DOMAIN + '/sharetreasure/modify';
export let URL_SHARETREASURE_CLOSE_START = DOMAIN + '/sharetreasure/close/start';
export let URL_GET_SHARETREASURE_LIST = DOMAIN + '/sharetreasure/list';
export let URL_GET_SHARETREASURE_SELECTLIST = DOMAIN + '/sharetreasure/selectlist';
export let URL_DELETE_SHARETREASURE = DOMAIN + '/sharetreasure/delete';
export let URL_CLOSE_SHARETREASURE = DOMAIN + '/sharetreasure/close';
export let URL_START_SHARETREASURE = DOMAIN + '/sharetreasure/start';
export let URL_GET_SHARETREASURE = DOMAIN + '/sharetreasure/get';
export let URL_SEARCH_SHARETREASURE = DOMAIN + '/sharetreasure/search';
export let URL_GET_SHARETREASURE_DETAIL = DOMAIN + '/sharetreasure/detail';
export let URL_SHARETREASURE_FANLOG = DOMAIN + '/sharetreasure/fan_stlog';
export let URL_SHARETREASURE_LIST_SUBSTITLE = DOMAIN + '/sharetreasure/list/substitle';
export let URL_SEARCH_SHARETREASURE_FANLOG = DOMAIN + '/sharetreasure/fan_stlog/search';
export let URL_ADD_CHANNELQRCODE = DOMAIN + '/channelqrcode/add';
export let URL_CHANNELQRCODE_SUBSLIST = DOMAIN + '/channelqrcode/subslist';
export let URL_EDIT_CHANNELQRCODE = DOMAIN + '/channelqrcode/edit';
export let URL_ADD_CHANNELQRCODE_GROUP = DOMAIN + '/channelqrcode/group/add';
export let URL_GET_CHANNELQRCODE_GROUPS = DOMAIN + '/channelqrcode/group/list';
export let URL_GET_CHANNELQRCODE_GROUPS1 = DOMAIN + '/channelqrcode/group/withqrcount/list';
export let URL_GET_CHANNELQRCODE_LIST = DOMAIN + '/channelqrcode/list';
export let URL_DELETE_CHANNELQRCODE = DOMAIN + '/channelqrcode/delete';
export let URL_DELETE_CHANNELQRCODE_GROUP = DOMAIN + '/channelqrcode/group/delete';
export let URL_CHANNELQRCODE_MV2GROUP = DOMAIN + '/channelqrcode/movetogroup';
export let URL_GET_CHANNELQRCODE = DOMAIN + '/channelqrcode/get';
export let URL_GET_CHANNELQRCODE_FANS = DOMAIN + '/channelqrcode/fanslist';
export let URL_DOWNLOAD_CHANNELQRCODE = DOMAIN + '/channelqrcode/download?id=';
export let URL_DOWNLOAD_GROUP_CHANNELQRCODE = DOMAIN + '/channelqrcode/group/download?id=';
export let URL_MODIFY_CHANNELQRCODE_NAME = DOMAIN + '/channelqrcode/name';
export let URL_MODIFY_CHANNELQRCODE_GROUPNAME = DOMAIN + '/channelqrcode/group/name';
export let URL_SEARCH_CHANNELQRCODE = DOMAIN + '/channelqrcode/search';
export let URL_SEARCH_CHANNELQRCODE_FANS = DOMAIN + '/channelqrcode/fans/search';
export let URL_CHANNELQRCODE_STATS_TOTAL = DOMAIN + '/channelqrcode/stats/total';
export let URL_CHANNELQRCODE_STATS_CHART = DOMAIN + '/channelqrcode/stats/chart';
export let URL_CHANNELQRCODE_STATS_EXPORT = DOMAIN + '/channelqrcode/stats/export';
export let URL_COMMON_UPLOADIMG = DOMAIN + '/common/uploadimg';
export let URL_WXMEDIA_ADDNEWS = DOMAIN + '/wx_media/add_news';
export let URL_WXMEDIA_EDITNEWS = DOMAIN + '/wx_media/edit_news';
export let URL_WXMEDIA_DELETENEWS = DOMAIN + '/wx_media/delete_news';
export let URL_GET_WXMEDIA_NEWS = DOMAIN + '/wx_media/news';
export let URL_SWITCH_SUBS = DOMAIN + '/user/switch_subs';
export let URL_TASKPOSTER_FANSSUPPORT = DOMAIN + '/taskposter/activefan/fanssupport';
export let URL_ADD_FORM = DOMAIN + '/form/add';
export let URL_MODIFY_FORM = DOMAIN + '/form/modify';
export let URL_GET_FORM_LIST = DOMAIN + '/form/list';
export let URL_GET_ALLFORM_LIST = DOMAIN + '/form/listall';
export let URL_GET_FORM = DOMAIN + '/form/get';
export let URL_DELETE_FORM = DOMAIN + '/form/delete';
export let URL_FORM_DATA = DOMAIN + '/form/data';
export let URL_GET_UNBOUND_FORM = DOMAIN + '/form/unbound';
export let URL_GET_LISTHEAD_FORM = DOMAIN + '/form/listhead';
export let URL_GET_DATA_FORMID_FORM = DOMAIN + '/form/data/formId';
export let URL_POST_EXPORT_FORM = DOMAIN + '/form/export';
export let URL_GET_PROMOINFO_FORM = DOMAIN + '/form/promoinfo';
export let URL_POST_SAVESELECT_FORM = DOMAIN + '/form/saveselect';
export let URL_POST_BROWSE_FORM = DOMAIN + '/form/browse';

export let URL_ADD_REDEEMCODE = DOMAIN + '/redeemcode/create';
export let URL_APPEND_REDEEMCODE = DOMAIN + '/redeemcode/append';
export let URL_GET_REDEEMCODE_LIST = DOMAIN + '/redeemcode/alllist';
export let URL_DELETE_REDEEMCODE = DOMAIN + '/redeemcode/delete';
export let URL_GET_ALLREDEEMCODE_LIST = DOMAIN + '/redeemcode/namelist';
export let URL_REDEEMCODE_DATA = DOMAIN + '/redeemcode/codelist';
export let URL_GET_UNBOUND_REDEEMCODE = DOMAIN + '/redeemcode/unbound';
export let URL_GET_BATCH_DELETE_REDEEMCODE = DOMAIN + '/redeemcode/invalid';
export let URL_DEL_TEMPLATETASK = DOMAIN + '/template_msg/task/delete';
export let URL_TP_CHANNEL_LIST = DOMAIN + '/taskposter/channelwords/list';
export let URL_MODIFY_TPCHANNEL_NAME = DOMAIN + '/taskposter/channelwords/name';
export let URL_DOWNLOAD_TPCHANNELQRCODE = DOMAIN + '/taskposter/channelwords/qrdl/';
export let URL_CREATE_TPCHANNEL = DOMAIN + '/taskposter/channelwords';
export let URL_TP_STATS_TOTAL = DOMAIN + '/taskposter/stats/total';
export let URL_TP_STATS_ABPOSTER_DATA = DOMAIN + '/taskposter/stats/abposter/data';
export let URL_TP_STATS_DAYDETAIL = DOMAIN + '/taskposter/stats/daydetail';
export let URL_GET_SUBS_LIST = DOMAIN + '/subs/list';
export let URL_TASKPOSTER_CHANNEL_DELETE = DOMAIN + '/taskposter/channelwords/delete';

// 任务宝-标签
export let URL_TASKPOSTER_QUERY = DOMAIN + '/taskposter/query';
export let URL_TASKPOSTER_GROUP_list = DOMAIN + '/taskposter/group/list';
export let URL_TASKPOSTER_GROUP_CREATE = DOMAIN + '/taskposter/group/create';
export let URL_TASKPOSTER_GROUP_EDIT = DOMAIN + '/taskposter/group/edit';
export let URL_TASKPOSTER_GROUP_DELETE = DOMAIN + '/taskposter/group/delete';
export let URL_TASKPOSTER_GROUP_MOVETO = DOMAIN + '/taskposter/moveto-group';

export let URL_GET_SHOPPING_LIST = DOMAIN + '/shopping/list';
export let URL_SHOPPING_DELETE = DOMAIN + '/shopping/delete';
export let URL_SHOPPING_ADD = DOMAIN + '/shopping/add';
export let URL_SHOPPING_AMOUNT = DOMAIN + '/shopping/amount';
export let URL_SHOPPING_PAY_PRODUCT = DOMAIN + '/shopping/select/detail';
export let URL_CREATE_ORDER = DOMAIN + '/order/create';
export let URL_CANCEL_ORDER = DOMAIN + '/order/cancle';
export let URL_ESSENTIAL = DOMAIN + '/order/essential';
export let URL_ORDER_LIST = DOMAIN + '/order/list';
export let URL_ORDER_DETAIL = DOMAIN + '/order/detail';
export let URL_SUBMIT_PAYVOUCHER = DOMAIN + '/order/submit/payVoucher';
export let URL_ORDER_STATUS = DOMAIN + '/order/status';
export let URL_IMAGES_UPLOAD = DOMAIN + '/images/upload';
export let URL_WXPAY_QRCODE = DOMAIN + '/wxpay/payqrcode';
export let URL_GET_NOBIND_TASKGOODS = DOMAIN + '/goods/notaskposter/list';

export let URL_GOODS_LIST = DOMAIN + '/goods/list'
export let URL_GOODS_DETAIL_QRCODE = DOMAIN + '/goods/detail/qrcode'
export let URL_GOODS_DETELE = DOMAIN + '/goods/delete'

export let URL_GOODSORDER_GOODNAME_LIST = DOMAIN + "/goodsOrder/goodsName/list"
export let URL_GOODSORDER_LIST = DOMAIN + "/goodsOrder/list"
export let URL_GOODSORDER_FANSORDER_LIST = DOMAIN + "/goodsOrder/fansOrder/list"
export let URL_GOODSORDER_DETAIL = DOMAIN + "/goodsOrder/detail"
export let URL_GOODSORDER_DELIVER = DOMAIN + "/goodsOrder/deliver"
export let URL_GOODSORDER_EXPORT = DOMAIN + "/goodsOrder/export"

// 商品添加
export let UEL_GOODS_ADD = DOMAIN + '/goods/add';
export let URL_GOODS_FORMAT_LIST = DOMAIN + '/goods/format/list';
export let URL_GOODS_FORMAT_ADD = DOMAIN + '/goods/format/add';
export let URL_GOODS_FORMAT_EDIT = DOMAIN + '/goods/format/edit';
export let URL_GOODS_PREVIEW = DOMAIN + '/goods/preview';
export let URL_GOODS_GET = DOMAIN + '/goods/get'
export let URL_GOODS_EDIT = DOMAIN + '/goods/edit'
export let URL_TP_TEMPLATE_CHECK = DOMAIN + '/taskposter/template_check';
export let URL_TP_BATCH_TEMPLATE_CHECK = DOMAIN + '/taskposter/batch_template_check';
export let URL_GOODS_NAMEUNIQUE = DOMAIN + '/goods/nameUnique';

// 首页
export let URL_HOME_PRODUCT_NOEXPIRE = DOMAIN + "/home/product/willexpire"
export let URL_HOME_ORDER_DATA = DOMAIN + "/home/order/data"
export let URL_HOME_TASKPOSTER_STATS_ALL_YESTERDAY = DOMAIN + "/taskposter/stats/all/yesterday"


// 黑名单
export let URL_BLACKLIST_ADD = DOMAIN + '/taskposter/blacklist/add';
export let URL_BLACKLIST_REMOVE = DOMAIN + '/taskposter/blacklist/remove';
export let URL_BLACKLIST_LISTALL = DOMAIN + '/taskposter/blacklist/listall';
export let URL_TASKPOSTER_BLACKLIST = DOMAIN + '/taskposter/activefan/list/inblacklist';
export let URL_TASKPOSTER_CHANNEL_CREATE = DOMAIN + '/taskposter/channelwords/add';
export let URL_TASKPOSTER_CHANNEL_EDIT = DOMAIN + '/taskposter/channelwords/modify';
export let URL_TP_CHANNEL_SUBSCHECK = DOMAIN + '/taskposter/channelwords/subscheck';
export let URL_TP_CHANNEL_EDIT = DOMAIN + '/taskposter/channelwords/';

// 头部导航
export let URL_NOTICE_LIST = DOMAIN + '/home/notice/list';
export let URL_NOTICE_READ = DOMAIN + '/home/notice/read';

// 续费
export let URL_ORDER_RENEW = DOMAIN + '/shopping/renew';
export let URL_ORDER_RENEW_ADD = DOMAIN + '/order/renew/add';

// 任务宝导出
export let URL_ACTIVEFAN_EXPORT = DOMAIN + '/taskposter/activefan/export';
export let URL_ACTIVEFAN_TAG = DOMAIN + '/taskposter/activefan/batchTagging';
export let URL_TASKPOSTER_STATS_EXPORT = DOMAIN + '/taskposter/stats/daydetail/export';

// 百度编辑器上传图片
// export let URL_UEDITOEUPLOAD = DOMAIN + '/ueditor/ueditorUpload.do';
export let URL_UEDITOEUPLOAD = DOMAIN + '/mfs/ueditor_upload';

// 官网首页
export let URL_WEBSITE = DOMAIN + '/home.html';

// 上传文件
export let URL_DISTRI_GOODS_AUDIO = DOMAIN + '/upload/audio';
export let URL_DISTRI_GOODS_UPLOAD = DOMAIN + '/mfs/upload';
export let ZKY_URL_DISTRI_GOODS_UPLOAD = DOMAIN + '/mfs/wxwupload'

// 分销
export let URL_DISTRI_GOODS_ADD = DOMAIN + '/distri/goods/add';
export let URL_DISTRI_GOODS_MODIFY = DOMAIN + '/distri/goods/modify';
export let URL_DISTRI_GOODS = DOMAIN + '/distri/goods';
export let URL_DISTRI_GOODS_QUERY = DOMAIN + '/distri/goods/query';
export let URL_DISTRI_GOODS_STATUS = DOMAIN + '/distri/goods/status';
export let URL_DISTRI_GOODS_DELETE = DOMAIN + '/distri/goods/delete';
export let URL_DISTRI_GOODS_PROMIINFO = DOMAIN + '/distri/goods/promoinfo';
export let URL_DISTRI_GOODS_SELECTLIST = DOMAIN + '/distri/goods/selectlist';
export let URL_DISTRI_INCOME = DOMAIN + '/distri/income';
export let URL_DISTRI_STATFLOW = DOMAIN + '/distri/statflow';
export let URL_DISTRI_RANKING = DOMAIN + '/distri/ranking';
export let URL_DISTRI_RECORD = DOMAIN + '/distri/inv_record';
export let URL_DISTRI_REDEEMCODELIST = DOMAIN + '/distri/redeemcodelist';
export let URL_DISTRI_ACCOUNTCASH = DOMAIN + '/distri/account_cash';
export let URL_DISTRI_WITHDRAW_APPLY = DOMAIN + '/distri/withdraw/apply';
export let URL_DISTRI_WITHDRAW_LIST = DOMAIN + '/distri/withdraw/list';
export let URL_DISTRI_QRCODE = DOMAIN + '/distri/subspayer/qrcode';
export let URL_DISTRI_GETINFO = DOMAIN + '/distri/subspayer/info';
export let URL_DISTRI_FEERATE = DOMAIN + '/distri/feerate';
export let URL_USER_LEVEL = DOMAIN + '/distri/viplevel';
export let URL_ORDERCHECKER_LIST = DOMAIN + '/orderchecker/list';
export let URL_ORDERCHECKER_AUTH_QRCODE = DOMAIN + '/orderchecker/auth_qrcode';
export let URL_ORDERCHECKER_AUTH_INFO = DOMAIN + '/orderchecker/auth_info';
export let URL_ORDERCHECKER_DELETE = DOMAIN + '/orderchecker/delete';
export let URL_ORDERCHECKER_ADD = DOMAIN + '/orderchecker/add';
export let URL_ORDERCHECKER_ORDERLIST = DOMAIN + '/orderchecker/orderlist';
export let URL_ORDERCHECKER_SELECTLIST = DOMAIN + '/orderchecker/selectlist';
export let URL_DISTRI_EXPORT = DOMAIN + '/distri/order/export';
export let URL_DISTRI_TASK_EXPORT = DOMAIN + '/distri/exporttask';


// 分销渠道码
export let URL_DISTRI_CHANNEL_PROMOINFO = DOMAIN + '/distri/channelwords/promoinfo';
export let URL_DISTRI_CHANNEL_LIST = DOMAIN + '/distri/channelwords/list';
export let URL_DISTRI_CHANNEL_EDIT = DOMAIN + '/distri/channelwords/edit';
export let URL_DISTRI_CHANNEL_CREATE = DOMAIN + '/distri/channelwords/create';
export let URL_DISTRI_CHANNEL_SELECTLIST = DOMAIN + '/distri/channelwords/selectlist';
export let URL_DISTRI_CHANNEL_DELETE = DOMAIN + '/distri/channelwords/delete';
export let URL_DISTRI_CHANNEL = DOMAIN + '/distri/channelwords';

// 分销消息模板
export let URL_DISTRI_NOTICECONFIG = DOMAIN + '/distri/noticeconfig/list';
export let URL_DISTRI_NOTICECONFIG_DEL = DOMAIN + '/distri/noticeconfig/delete';
export let URL_DISTRI_NOTICECONFIG_ADD = DOMAIN + '/distri/noticeconfig/add';
export let URL_DISTRI_NOTICECONFIG_EDIT = DOMAIN + '/distri/noticeconfig/edit';
export let URL_DISTRI_NOTICECONFIG_DETAIL = DOMAIN + '/distri/noticeconfig/detail';

// 推送
export let URL_PUSH_TASK_ADD = DOMAIN + '/pushfansMsg/task/add';
export let URL_PUAH_TASK_DETAIL = DOMAIN + '/pushfansMsg/task/detail';
export let URL_PUSH_TASK_MODIFY = DOMAIN + '/pushfansMsg/task/modify';
export let URL_PUSH_TASK_TITLEUNQUIUE = DOMAIN + '/pushfansMsg/task/titleUnqiue';
export let URL_PUSH_TASK_LIST = DOMAIN + '/pushfansMsg/task/list';
export let URL_PUSH_TASK_DEL = DOMAIN + '/pushfansMsg/task/delete';
export let URL_PUSH_TASK_CHANGEOPEN = DOMAIN + '/pushfansMsg/task/changeOpen';
export let URL_PUSH_TSAK_LOG = DOMAIN + '/pushfansMsg/push/log';
export let URL_PUSH_TSAK_LOG_EXPORT = DOMAIN + '/pushfansMsg/push/log/export';
export let URL_PUSH_TSAK_PREVIEW = DOMAIN + '/pushfansMsg/task/preview';

// 拼团
export let URL_GROUPBUY_GOODS_ADD = DOMAIN + '/groupbuy/goods/add';
export let URL_GROUPBUY_GOODS_MODIFY = DOMAIN + '/groupbuy/goods/modify';
export let URL_GROUPBUY_GOODS_DETAIL = DOMAIN + '/groupbuy/goods';
export let URL_GROUPBUY_GOODS_LIST = DOMAIN + '/groupbuy/goods/query';
export let URL_GROUPBUY_GOODS_STATUS = DOMAIN + '/groupbuy/goods/status';
export let URL_GROUPBUY_GOODS_DELETE = DOMAIN + '/groupbuy/goods/delete';
export let URL_GROUPBUY_GOODS_PROMOINFO = DOMAIN + '/groupbuy/goods/promoinfo';
export let URL_GROUPBUY_GOODS_SELECTLIST = DOMAIN + '/groupbuy/goods/selectlist';
export let URL_GROUPBUY_ORDER_LIST = DOMAIN + '/groupbuy/order/list';
export let URL_GROUPBUY_ORDER_DETAIL = DOMAIN + '/groupbuy/order';
export let URL_GROUPBUY_ORDER_DELIVER = DOMAIN + '/groupbuy/order/deliver';
export let URL_GROUPBUY_ORDER_SELECTLIST = DOMAIN + '/groupbuy/goods/selectlist';
export let URL_GROUPBUY_ACCOUNT_CASH = DOMAIN + '/groupbuy/account_cash';
export let URL_GROUPBUY_WITHDREW_LIST = DOMAIN + '/groupbuy/withdraw/list';
export let URL_GROUPBUY_SUBSPAYER_INFO = DOMAIN + '/groupbuy/subspayer/info';
export let URL_GROUPBUY_WITHDRAW_APPLY = DOMAIN + '/groupbuy/withdraw/apply';
export let URL_GROUPBUY_REDEEMCODELIST = DOMAIN + '/groupbuy/redeemcodelist';
export let URL_GROUPBUY_NOTICECONFIG = DOMAIN + '/groupbuy/noticeconfig/list';
export let URL_GROUPBUY_NOTICECONFIG_DEL = DOMAIN + '/groupbuy/noticeconfig/delete';
export let URL_GROUPBUY_NOTICECONFIG_ADD = DOMAIN + '/groupbuy/noticeconfig/add';
export let URL_GROUPBUY_NOTICECONFIG_EDIT = DOMAIN + '/groupbuy/noticeconfig/edit';
export let URL_GROUPBUY_NOTICECONFIG_DETAIL = DOMAIN + '/groupbuy/noticeconfig/detail';
export let URL_GROUPBUY_LEVEL = DOMAIN + '/groupbuy/viplevel';
export let URL_GROUPBUY_EXPORT = DOMAIN + '/groupbuy/order/export';

//批量发货  下载失败数据
export let URL_ORDER_BULK_DELIVER_DOWN_LOAD_FAIL = DOMAIN + '/order/bulkdeliver/downloadFail'


// 活码

// 通用
export let URL_LIVECODE_PROMOINFO = DOMAIN + '/livecode/promoinfo';
export let URL_LIVECODE_DELETE = DOMAIN + '/livecode/delete';
export let URL_LIVECODE_STATUS = DOMAIN + '/livecode/status';

// 客服码
export let URL_LIVECODE_CUSTOMER_CREATE = DOMAIN + '/livecode/kf/code_create';
export let URL_LIVECODE_CUSTOMER_EDIT = DOMAIN + '/livecode/kf/code_edit';
export let URL_LIVECODE_CUSTOMER_LIST = DOMAIN + '/livecode/kf/code_list';
export let URL_LIVECODE_CUSTOMER_DETAIL = DOMAIN + '/livecode/kf/code_detail';
export let URL_LIVECODE_CUSTOMER_QRCODE_LIST = DOMAIN + '/livecode/kf/qrcode_list';
export let URL_LIVECODE_CUSTOMER_QRCODE_ACTIVE = DOMAIN + '/livecode/kf/qrcode_active';
export let URL_LIVECODE_CUSTOMER_QRCODE_Add = DOMAIN + '/livecode/kf/qrcode_add';
export let URL_LIVECODE_CUSTOMER_QRCODE_EDIT = DOMAIN + '/livecode/kf/qrcode_edit';
export let URL_LIVECODE_CUSTOMER_QRCODE_REPLACE = DOMAIN + '/livecode/kf/qrcode_replace';
export let URL_LIVECODE_CUSTOMER_QRCODE_DELETE = DOMAIN + '/livecode/kf/qrcode_delete';
export let URL_LIVECODE_CUSTOMER_QRCODE_SCANLIMIT = DOMAIN + '/livecode/kf/qrcode_scanlimit';
export let URL_LIVECODE_CUSTOMER_INDEX = DOMAIN + '/livecode/kf/qrcode_index';
export let URL_LIVECODE_CUSTOMER_QRCODE_CLOSE = DOMAIN + '/livecode/kf/qrcode_close';
export let URL_LIVECODE_CUSTOMER_QRCODE_OPEN = DOMAIN + '/livecode/kf/qrcode_open';

// 群活码
export let URL_LIVECODE_GROUP_TAGS_LIST = DOMAIN + '/livecode/qun/tag_list';
export let URL_LIVECODE_GROUP_TAGS_CREATE = DOMAIN + '/livecode/qun/tag_create';
export let URL_LIVECODE_GROUP_TAGS_DEL = DOMAIN + '/livecode/qun/tag_delete';
export let URL_LIVECODE_GROUP_TAGS_EDIT = DOMAIN + '/livecode/qun/tag_edit';
export let URL_LIVECODE_GROUP_CREATE = DOMAIN + '/livecode/qun/code_create';
export let URL_LIVECODE_GROUP_EDIT = DOMAIN + '/livecode/qun/code_edit';
export let URL_LIVECODE_GROUP_LIST = DOMAIN + '/livecode/qun/code_list';
export let URL_LIVECODE_GROUP_DETAIL = DOMAIN + '/livecode/qun/code_detail';
export let URL_LIVECODE_GROUP_QRCODE_LIST = DOMAIN + '/livecode/qun/qrcode_list';
export let URL_LIVECODE_GROUP_QRCODE_ACTIVE = DOMAIN + '/livecode/qun/qrcode_active';
export let URL_LIVECODE_GROUP_QRCODE_ADD = DOMAIN + '/livecode/qun/qrcode_add';
export let URL_LIVECODE_GROUP_QRCODE_EDIT = DOMAIN + '/livecode/qun/qrcode_edit';
export let URL_LIVECODE_GROUP_QRCODE_REPLACE = DOMAIN + '/livecode/qun/qrcode_replace';
export let URL_LIVECODE_GROUP_QRCODE_DELETE = DOMAIN + '/livecode/qun/qrcode_delete';
export let URL_LIVECODE_GROUP_QRCODE_SCANLIMIT = DOMAIN + '/livecode/qun/qrcode_scanlimit';
export let URL_LIVECODE_GROUP_QRCODE_EXPIRE = DOMAIN + '/livecode/qun/qrcode_expire';
export let URL_LIVECODE_LEVEL = DOMAIN + '/livecode/vippay';
export let URL_LIVECODE_GROUP_INDEX = DOMAIN + '/livecode/qun/qrcode_index';
export let URL_LIVECODE_GROUP_QRCODE_CLOSE = DOMAIN + '/livecode/qun/qrcode_close';
export let URL_LIVECODE_GROUP_QRCODE_OPEN = DOMAIN + '/livecode/qun/qrcode_open';

// 数据统计
export let URL_LIVECODE_ALLCODE = DOMAIN + '/livecode/allcode';
export let URL_LIVECODE_STAT_TREND = DOMAIN + '/livecode/stat/trend';
export let URL_LIVECODE_STAT_AREADISTRI = DOMAIN + '/livecode/stat/arealdistri';

// 自定义菜单
export let URL_SUBSMEMU_SELECTMENU = DOMAIN + '/subsmenu/selectmenu'
export let URL_SUBSMEMU_CREATEMENU = DOMAIN + '/subsmenu/createmenu'
export let URL_SUBSMEMU_SELECTONE = DOMAIN + '/subsmenu/selectone'
export let URL_SUBSMEMU_GXHLIST = DOMAIN + '/subsmenu/gxhlist'
export let URL_SUBSMEMU_EDITSTATU = DOMAIN + '/subsmenu/editstatu'
export let URL_SUBSMEMU_DELMENU = DOMAIN + '/subsmenu/delmenu'
export let URL_SUBSMEMU_EDITMENU = DOMAIN + '/subsmenu/editmenu'
export let URL_SUBSMEMU_SELECTAUTOREPLY = DOMAIN + '/subsmenu/selectAutoreply'
export let URL_SUBSMEMU_AUTOREPLY = DOMAIN + '/subsmenu/autoreply'
export let URL_SUBSMEMU_DELALLMENU = DOMAIN + '/subsmenu/delallmenu'

export let URL_GET_MSG_TEMPLATE_SUB_ONTRIAL = DOMAIN + '/subs/ontrial';

// 购买中心
export let URL_PRODUCT_PURLIST = DOMAIN + '/product/purlist';
export let URL_PRODUCT_PRICELIST = DOMAIN + '/product/pricelist';
export let URL_PRODUCT_PAYAMOUNT = DOMAIN + '/product/payamount';


export let URL_HELP_GETDOC = DOMAIN + "/help/getdoc"
export let URL_HELP_GETCONTENT = DOMAIN + "/help/getcontent"
export let URL_HELP_LISTMENU = DOMAIN + "/help/listmenu"


export let NOHEADIMG = 'https://static.94mxd.com.cn/images/wx_noheadimg.png';


// 导航栏
export let URL_NAV_CONFIG = DOMAIN + "/nav/config";


// 企业微信
export let URL_CORP_CUSFISSION_QUERY = DOMAIN + "/corp/cusfission/query";
export let URL_CORP_CUSFISSION_STATUS = DOMAIN + "/corp/cusfission/status";
export let URL_CORP_CUSFISSION_DELETE = DOMAIN + "/corp/cusfission/delete";
export let URL_CORP_APP_AUTH_URL = DOMAIN + "/corp/app/auth_uri";
export let URL_CORP_APP_AGENT_CONFIG = DOMAIN + "/corp/app/agent_config";
export let URL_CORP_CUSFISSION_CREATE = DOMAIN + '/corp/cusfission/create';
export let URL_CORP_CUSFISSION_EDIT = DOMAIN + '/corp/cusfission/edit';
export let URL_CORP_CUSFISSION_DETAIL = DOMAIN + '/corp/cusfission/detail';
export let URL_CORP_MEMBER_FISSION_LIST = DOMAIN + '/corp/member/fission_list';
export let URL_CORP_APP_AUTH_LIST = DOMAIN + '/corp/app/auth_list';
export let URL_CORP_MEMBER_LIST = DOMAIN + "/corp/member/list";
export let URL_CORP_MEMBER_BATCH_FISSION = DOMAIN + "/corp/member/batch_fission";
export let URL_CORP_CUSFISSION_CHANNEK_SUBS_LIST = DOMAIN + '/corp/cusfission/channel_subs_list';
export let URL_CORP_CUSFISSION_SELECTLIST = DOMAIN + '/corp/cusfission/selectlist';
export let URL_CORP_MEMBER_SYNC = DOMAIN + "/corp/member/sync";
export let URL_CORP_CUSFISSION_STATS_TOTAL = DOMAIN + "/corp/cusfission/stats/total";
export let URL_CORP_CUSFISSION_STATS_DAYDETAIL = DOMAIN + "/corp/cusfission/stats/daydetail";
export let URL_CORP_CUSFISSION_STATS_TODAYDETAIL = DOMAIN + "/corp/cusfission/stats/todaydetail";
export let URL_CORP_CUSFISSION_STATS_DAYDETAIL_EXPORT = DOMAIN + "/corp/cusfission/stats/daydetail/export";
export let URL_CORP_CUSFISSION_ACTIVEFAN_LIST = DOMAIN + '/corp/cusfission/activefan/list';
export let URL_CORP_CUSFISSION_ACTIVEFAN_SEARCH = DOMAIN + '/corp/cusfission/activefan/search';
export let URL_CORP_CUSFISSION_ACTIVEFAN_PRIZE = DOMAIN + '/corp/cusfission/activefan/prize';
export let URL_CORP_CUSFISSION_ACTIVEFAN_REMARK = DOMAIN + '/corp/cusfission/activefan/remark';
export let URL_CORP_CUSFISSION_ACTIVEFAN_STAS = DOMAIN + '/corp/cusfission/activefan/stas';
export let URL_CORP_CUSFISSION_ACTIVEFAN_FANSSUPPORT = DOMAIN + '/corp/cusfission/activefan/fanssupport';
export let URL_CORP_CUSFISSION_ACTIVEFAN_BATCHTAGGING = DOMAIN + '/corp/cusfission/activefan/batchTagging';
export let URL_CORP_CUSFISSION_ACTIVEFAN_EXPORT = DOMAIN + '/corp/cusfission/activefan/export';
export let URL_GET_CUSFISSION_LTM = DOMAIN + '/corp/cusfission/ltm';
export let URL_CORP_MEMBER_SEARCH = DOMAIN + '/corp/member/search';


/*物流查询*/
export let URL_LOGISTICS_CREATE = DOMAIN + '/logistics/create';
export let URL_LOGISTICS_DETAIL = DOMAIN + '/logistics/detail';
export let URL_LOGISTICS_EDIT = DOMAIN + '/logistics/edit';


// 物流
export let URL_LOGISTICS_LIST = DOMAIN + '/logistics/list';
export let URL_LOGISTICS_OPENURL = DOMAIN + '/logistics/openurl';
export let URL_LOGISTICS_ALLOPENURL = DOMAIN + '/logistics/allopenurl';
export let URL_LOGISTICS_DELETE = DOMAIN + '/logistics/delete';
export let URL_LOGISTICS_DATA_APPEND = DOMAIN + '/logistics/data/append';
export let URL_LOGISTICS_DATA_LIST = DOMAIN + '/logistics/data/list';
export let URL_LOGISTICS_DATA_DELETE = DOMAIN + '/logistics/data/delete';
export let URL_LOGISTICS_DATA_CUSTOM_FIELD = DOMAIN + '/logistics/data/custom_field';
export let URL_GET_TASKPOSTER_LINKINFO = DOMAIN + '/taskposter/linkinfo';

//节日签
export let URL_QUERY_FESTIVAL_ACTIVITYLIST = DOMAIN + '/festivalsign/activity_list';
export let URL_DELETE_FESTIVAL_ACTIVITYLIST = DOMAIN + '/festivalsign/activity_del';
export let URL_CREATE_FESTIVAL_ACTIVITY = DOMAIN + '/festivalsign/activity_create';
export let URL_EDIT_FESTIVAL_ACTIVITY = DOMAIN + '/festivalsign/activity_edit';
export let URL_MODIFY_FESTIVAL_ACTIVITY_STATUS = DOMAIN + '/festivalsign/activity_status';
export let URL_GET_FESTIVAL_ACTIVITY_DETAIL = DOMAIN + '/festivalsign/activity_detail';
export let URL_GET_GOODSORDER_CHECKER_LIST = DOMAIN + '/orderchecker/list';
export let URL_GOODSORDER_CHECKER_AUTH_QRCODE = DOMAIN + '/orderchecker/auth_qrcode';
export let URL_GOODSORDER_CHECKER_AUTH_INFO = DOMAIN + '/orderchecker/auth_info';
export let URL_ADD_GOODSORDER_CHECKER = DOMAIN + '/orderchecker/add';
export let URL_DEL_GOODSORDER_CHECKER = DOMAIN + '/orderchecker/delete';
export let URL_QUERY_GOODSCHECKER_ORDER = DOMAIN + '/orderchecker/orderlist';
export let URL_GET_GOODSCHECKER_NAMELIST = DOMAIN + '/orderchecker/selectlist';
export let URL_GET_GOODSORDER_DELIVER_RECORDLIST = DOMAIN + '/goodsOrder/bulkdeliver/recordlist';
export let URL_DEL_GOODSORDER_DELIVER_RECORD = DOMAIN + '/goodsOrder/bulkdeliver/delete';
export let URL_QUERY_GOODSORDER_LIST = DOMAIN + '/goodsOrder/query';
export let URL_GET_GOODSORDER_DATASTATS = DOMAIN + '/goodsOrder/dataStats';
export let URL_GET_GOODSORDER_BUYERINFO = DOMAIN + '/goodsOrder/buyerInfo';
export let URL_DELIVER_GOODSORDER = DOMAIN + '/goodsOrder/deliver';
export let URL_EDIT_GOODSORDER_DELIVERINFO = DOMAIN + '/goodsOrder/deliverInfo';
export let URL_UPLOAD_GOODSORDER_BULKDELIVER_DATA = DOMAIN + '/goodsOrder/bulkdeliver/uploadData';
export let URL_DOWNLOAD_GOODSORDER_BULKDELIVER_FAILDATA = DOMAIN + '/goodsOrder/bulkdeliver/downloadFail';
export let URL_GET_SYSTEM_UPGRADE_NEWCOUNT = DOMAIN + '/sysupgrade/newcount';
export let URL_VIEWCILCK_SYSTEM_UPGRADE = DOMAIN + '/sysupgrade/viewclick';

//一元解锁
export let URL_MXD_BOOST_EDIT = DOMAIN + '/boost/edit';
export let URL_MXD_BOOST_DETAIL = DOMAIN + '/boost/detail';
export let URL_MXD_BOOST_ORDER_UPDATEFILLINFO = DOMAIN + '/boost/order/updateFillInfo';//编辑填写信息
export let URL_MXD_BOOST_MENULIST = DOMAIN + '/boost/menulist';//数据分析活动列表
export let URL_MXD_BOOST_ENABLE = DOMAIN + '/boost/enable';
export let URL_MXD_BOOST_DISABLE = DOMAIN + '/boost/disable';
export let URL_MXD_BOOST_ORDER_DETAIL = DOMAIN + '/boost/order/detail';//订单详情
export let URL_MXD_BOOST_DELETE = DOMAIN + '/boost/delete';
export let URL_MXD_BOOST_PROMOTO = DOMAIN + '/boost/promoto';
export let URL_MXD_BOOST_INVDETAIL = DOMAIN + '/boost/invDetail'; // 用户邀请详情
export let URL_MXD_BOOST_JOINLIST = DOMAIN + '/boost/joinlist'; //参与粉丝列表
export let URL_MXD_BOOST_ORDER_LIST = DOMAIN + '/boost/order/list';
export let URL_MXD_BOOST_ORDER_EXPORT = DOMAIN + '/boost/order/export';
export let URL_MXD_BOOST_TASK_EXPORT = DOMAIN + '/boost/exporttask';
export let URL_MXD_BOOST_CUSTOMER_EXPORT = DOMAIN + '/boost/exportCus';
export let URL_MXD_BOOST_CREATE = DOMAIN + '/boost/create';
export let URL_MXD_BOOST_LIST = DOMAIN + '/boost/list';

//一元解锁数据统计
export let URL_MXD_BOOST_STATEXPORT = DOMAIN + '/boost/statExport';
export let URL_MXD_BOOST_STAT = DOMAIN + '/boost/stat';
//分销管理
export let URL_MXD_DISTRI_CREATE = DOMAIN + '/distri/create';
export let URL_MXD_DISTRI_QUERY = DOMAIN + '/distri/query';
export let URL_MXD_DISTRI_PROMOINFO = DOMAIN + '/distri/promoinfo';
export let URL_MXD_DISTRI_DELETE = DOMAIN + '/distri/delete';
export let URL_MXD_DISTRI_TURNOFF = DOMAIN + '/distri/turnoff';
export let URL_MXD_DISTRI_TURNON = DOMAIN + '/distri/turnon';
export let URL_MXD_DISTRI_MODIFY = DOMAIN + '/distri/modify';
export let URL_MXD_DISTRI_DETAIL = DOMAIN + '/distri/detail'
export let URL_MXD_DISTRI_MENULIST = DOMAIN + '/distri/menulist';
// 收益排行榜 导出 统计
export let URL_MXD_DISTRI_RANK_EXPORT = DOMAIN + '/distri/rank_export';
export let URL_MXD_DISTRI_RANK = DOMAIN + '/distri/rank';
export let URL_MXD_DISTRI_RANKSTAT = DOMAIN + '/distri/rankStat';
export let URL_MXD_DISTRI_INVITDETAIL = DOMAIN + '/distri/invitDetail';
//活动数据 导出 统计
export let URL_MXD_DISTRI_STATS_EXPORT = DOMAIN + '/distri/stats_export';
export let URL_MXD_DISTRI_STATS = DOMAIN + '/distri/stats';
//订单管理 详情 列表
export let URL_MXD_DISTRI_ORDERDETAIL = DOMAIN + '/distri/orderdetail';
export let URL_MXD_DISTRI_ORDERLIST = DOMAIN + '/distri/orderlist';
export let URL_MXD_DISTRI_ORDERSTAT = DOMAIN + '/distri/orderstat';
export let URL_MXD_DISTRI_ORDER_EXPORT = DOMAIN + '/distri/orderexport';
export let URL_MXD_ORDER_DELIVERY = DOMAIN + '/order/delivery';
export let URL_MXD_ORDER_REFUND_AMOUNT = DOMAIN + '/order/refund/amount';
export let URL_MXD_ORDER_SELLERAPPLYREFUND = DOMAIN + '/order/sellerApplyRefund';

// 上传文件
export let URL_MXD_MFS_UPLOAD = DOMAIN + '/mfs/upload';
// 商品规格
export let URL_MXD_SPEC_GROUP_LIST = DOMAIN + '/spec/group/list';
export let URL_MXD_SPEC_GROUP_CREATE = DOMAIN + '/spec/group/create';
export let URL_MXD_SPEC_CREATE = DOMAIN + '/spec/create';
export let URL_MXD_SPEC_DELETE = DOMAIN + '/spec/delete';
//消息模板
export let URL_MXD_DISTRI_NOTICECONFIG_DETAIL = DOMAIN + '/distri/noticeconfig/detail';
export let URL_MXD_DISTRI_NOTICECONFIG_LIST = DOMAIN + '/distri/noticeconfig/list';
export let URL_MXD_DISTRI_NOTICECONFIG_ADD = DOMAIN + '/distri/noticeconfig/add';
export let URL_MXD_DISTRI_NOTICECONFIG_EDIT = DOMAIN + '/distri/noticeconfig/edit';
export let URL_MXD_DISTRI_NOTICECONFIG_DELETE = DOMAIN + '/distri/noticeconfig/delete';
export let URLMXD_SUBS_MAG_TEMPLATE_LIST = DOMAIN + '/conf/subs/msg_template_list'
//渠道管理
export let URL_MXD_DISTRI_CHANNEL_QUERY = DOMAIN + '/distri/channel/query';
export let URL_MXD_DISTRI_CHANNEL_DETAIL = DOMAIN + '/distri/channel/detail';
export let URL_MXD_DISTRI_CHANNEL_DELETE = DOMAIN + '/distri/channel/delete';
export let URL_MXD_DISTRI_CHANNEL_MODIFY = DOMAIN + '/distri/channel/modify';
export let URL_MXD_DISTRI_CHANNEL_CREATE = DOMAIN + '/distri/channel/create';
export let URL_MXD_DISTRI_CHANNEL_MENULIST = DOMAIN + '/distri/channel/menulist';
export let URL_MXD_DISTRI_CHANNEL_PRICE = DOMAIN + '/distri/price'

//获取兑换码无列表
export let URL_MXD_REDEEMCODE_UNBINDLIST = DOMAIN + '/redeemcode/unbindlist'
//获取客服列表
export let URL_MXD_CONF_CUSTOMMER_SERVICE_lIST = DOMAIN + '/conf/customer_service/list';
//获取公众号基本信息
export let URL_MXD_CONF_SUBS_BASEINFO = DOMAIN + '/conf/subs/base_info'


//配置-客服配置
export let URL_MXD_CONFIG_CSERVER_ADD = DOMAIN + '/conf/customer_service/add';  //添加客服
export let URL_MXD_CONFIG_CSERVER_EDIT = DOMAIN + '/conf/customer_service/modify';  //添加客服
export let URL_MXD_CONFIG_CSERVER_LIST = DOMAIN + '/conf/customer_service/list';  //客服列表
export let URL_MXD_CONFIG_CSERVER_DEL = DOMAIN + '/conf/customer_service/delete';  //删除客服
//商家设置
export let URL_MXD_CONFIG_BRAND_DETAIL = DOMAIN + '/conf/business/detail';  //获取商家设置
export let URL_MXD_CONFIG_BRAND_SET = DOMAIN + '/conf/business/set';  //修改商家设置
//公众号配置
export let URL_MXD_CONFIG_OA_BASE = DOMAIN + '/conf/subs/base_info';//获取公众号配置基本信息
export let URL_MXD_CONFIG_OA_WXAUTH = DOMAIN + '/wechat/auth_uri';  //获取公众号授权页面地址
export let URL_MXD_CONFIG_OA_DETAIL = DOMAIN + '/conf/subs/detail';//获取公众号配置基本信息
export let URL_MXD_CONFIG_OA_SUBS_UNBIND = DOMAIN + '/conf/subs/unbind'
//支付配置
export let URL_PAYCONFIG_WX_DETAIL = DOMAIN + '/conf/payconfig/wx/detail'//获取微信支付配置详情
export let URL_PAYCONFIG_WX_STATUS = DOMAIN + '/conf/payconfig/wx/status' //开启关闭自有商户

//资产
export let URL_MXD_ASSETS_CASHABLE = DOMAIN + '/assets/account/cashable';//获取可提现金额
export let URL_MXD_ASSETS_PENDING = DOMAIN + '/assets/account/pending_settle';//获取待结算金额
export let URL_MXD_ASSETS_UNUSABLE = DOMAIN + '/assets/account/unavailable_amount';//获取不可用金额
export let URL_MXD_ASSETS_STATEMENT = DOMAIN + '/assets/statement/details';//获取对账单明细
export let URL_MXD_ASSETS_STATEMENTEXPORT = DOMAIN + '//assets/statement/export';//获取对账单明细
export let URL_MXD_ASSETS_WITHDRAWLIST = DOMAIN + '/assets/withdraw/record_list';//获取提现记录
export let URL_MXD_ASSETS_CASHQRCODE = DOMAIN + '/assets/withdraw/applyer/authqrcode';//提现扫码
export let URL_MXD_ASSETS_CURAPPLYER = DOMAIN + '/assets/withdraw/cur_applyer';//提现扫码
export let URL_MXD_ASSETS_AUTHINFO = DOMAIN + '//assets/withdraw/applyer/authinfo';//提现扫码获取客户头图昵称
export let URL_MXD_ASSETS_ACCOUNT_PENDING_SETTLE_LIST = DOMAIN + '/assets/account/pending_settle_list';//未结算列表
export let URL_MXD_ASSETS_ACCOUNT_PENDING_SETTLE_LIST_EXPORT = DOMAIN + '/assets/account/pending_settle_list_export'//未结算列表导出
export let URL_MXD_ASSETS_ACCOUNT_COPLETE_SETTLE_LIST = DOMAIN + '/assets/account/complete_settle_list'; //已结算列表
export let URL_MXD_ASSETS_ACCOUNT_COMPLETE_SETTLE_LIST_EXPORT = DOMAIN + '/assets/account/complete_settle_list_export'

// 拼团
export let URL_MXD_GROUPBUY_QUERY_NORMAL = DOMAIN + '/groupbuy/query/normal';//普通拼团活动列表
export let URL_MXD_GROUPBUY_QUERY_LADDAR = DOMAIN + '/groupbuy/query/laddar';//阶梯拼团活动列表
export let URL_MXD_GROUPBUY_PROMOINFO = DOMAIN + '/groupbuy/promoinfo';// 推广
export let URL_MXD_GROUPBUY_DELETE = DOMAIN + '/groupbuy/delete';
export let URL_MXD_GROUPBUY_LADDER_DELETE = DOMAIN + '/groupbuy/laddar/del';
export let URL_MXD_GROUPBUY_TURNOFF = DOMAIN + '/groupbuy/turnoff';
export let URL_MXD_GROUPBUY_TURNON = DOMAIN + '/groupbuy/turnon';
export let URL_MXD_GROUPBUY_NAMES_LADDAR = DOMAIN + '/groupbuy/names/laddar';
export let URL_MXD_GROUPBUY_NAMES_NORMAL = DOMAIN + '/groupbuy/names/normal';
export let URL_MXD_GROUPBUY_ORDER_QUERY = DOMAIN + '/groupbuy/order/query';
export let URL_MXD_GROUPBUY_ORDER_QUERY_EXPORT = DOMAIN + '/groupbuy/order/query/export';
export let URL_MXD_GROUPBUY_ORDER_GROUP = DOMAIN + '/groupbuy/order/group';
export let URL_MXD_GROUPBUY_ORDER_DETAIL = DOMAIN + '/groupbuy/order/detail';
export let URL_MXD_GROUPBUY_STATS_NORMAL_GROUPSLIST = DOMAIN + '/groupbuy/stats/normal/groupslist'; // 普通拼团情况列表
export let URL_MXD_GROUPBUY_STATS_NORMAL_GROUPSDATA = DOMAIN + '/groupbuy/stats/normal/groupsdata'; // 普通拼团DATA
export let URL_MXD_GROUPBUY_STATS_LADDAR_GROUPSLIST = DOMAIN + '/groupbuy/stats/ladder/groupslist'; // 阶梯拼团情况列表
export let URL_MXD_GROUPBUY_STATS_LADDAR_GROUPSDATA = DOMAIN + '/groupbuy/stats/ladder/groupsdata'; // 阶梯拼团DATA
export let URL_MXD_GROUPBUY_CREATE = DOMAIN + '/groupbuy/create';
export let URL_MXD_GROUPBUY_UPDATE = DOMAIN + '/groupbuy/update';
export let URL_MXD_GROUPBUY_DETAIL = DOMAIN + '/groupbuy/detail';
export let URL_MXD_GROUPBUY_STATS_GROUP_DETAIL = DOMAIN + '/groupbuy/stats/group/detail'; // 拼团团情况
export let URL_MXD_GROUPBUY_STATS_NORMAL_GROUPLIST_EXPORT = DOMAIN + '/groupbuy/stats/normal/groupslist/export'; // 拼团团情况导出
export let URL_MXD_GROUPBUY_STATS_LADDAR_GROUPLIST_EXPORT = DOMAIN + '/groupbuy/stats/ladder/groupslist/export'; // 阶梯拼团团情况导出
export let URL_MXD_GROUPBUY_STATS_LADDAR_DATA = DOMAIN + '/groupbuy/stats/ladder/data'; // 阶梯活动数据
export let URL_MXD_GROUPBUY_STATS_NORMAL_DATA = DOMAIN + '/groupbuy/stats/normal/data'; // 阶梯活动数据
export let URL_MXD_GROUPBUY_STATS_LADDAR_DATA_EXPORT = DOMAIN + '/groupbuy/stats/ladder/data/export'; // 阶梯数据统计导出
export let URL_MXD_GROUPBUY_STATS_NORMAL_DATA_EXPORT = DOMAIN + '/groupbuy/stats/normal/data/export'; // 普通数据统计导出
export let URL_MXD_GROUPBUY_NOTICE_DETAIL = DOMAIN + '/groupbuy/notice/detail';
export let URL_MXD_GROUPBUY_NOTICE_ADD = DOMAIN + '/groupbuy/notice/add';
export let URL_MXD_ASSETS_STATEMENT_SUMMARY = DOMAIN + '/assets/statement/summary'; //对账单汇总

//任务宝活动数据 导出
export let URL_ACTIVITY_DATA_EXPORT = DOMAIN + '/corp/taskactivity/activitystats/export' // 数据统计导出
export let URL_ACTIVITY_CUSTOMER_STATS_EXPORT = DOMAIN + '/corp/taskactivity/customerstats/export' //参与用户 导出

//群裂变群聊数据 导出
export let URL_GROUP_STATS_EXPORT = DOMAIN + '/corp/groupfission/groupstats_export' //群裂变 群聊数据 导出
export let URL_GROUP_CUSTOMER_EXPORT = DOMAIN + '/corp/groupfission/customerstats_export' //群裂变 客户数据 导出

//红包数据统计导出
export let URL_REDPACKET_EXPORT = DOMAIN + '/redpacket/customerlistExport' //红包数据统计导出

//渠道活码的下载
export let URL_LIVE_CODE_DOWN_LOAD = DOMAIN + '/corp/livecode/download'
export let URL_LIVE_CODE_BAT_DOWN_LOAD = DOMAIN + '/corp/livecode/batdownload'//批量下载
//渠道活码对比数据的导出
export let URL_LIVE_CODE_STATS_COMPARE_EXPORT = DOMAIN + '/corp/livecode/statscompare/export'
//渠道活码集合数据的导出
export let URL_LIVE_CODE_STATS_SET_EXPORT = DOMAIN + '/corp/livecode/statsset/export'

//渠道活码集合数据按时间查看的导出
export let URL_LIVE_CODE_STATS_SET_TIMER_ANGE_EXPORT = DOMAIN + '/corp/livecode/statsset/timerange/export'
//渠道活码集合数据按员工查看的导出
export let URL_LIVE_CODE_STATS_SET_MEMBER_DATA_EXPORT = DOMAIN + '/corp/livecode/statsset/memberdata/export'


//抽奖裂变的导出
export let URL_LOTTERY_CUSTOMER_LIST_EXPORT = DOMAIN + '/corp/lottery/customerlistExport'

//群红包的导出
export let URL_GROUPRED_GROUP_EXPORT = DOMAIN + '/corp/group/redpacket/group_export'
export let URL_GROUPRED_CUSTOMER_EXPORT = DOMAIN + '/corp/group/redpacket/customer_export'

//好友群发的导出
export let URL_CLOUD_GROUPSEND_EXPIOR = DOMAIN + '/wxw/groupmsg/friend/record_export'

//群sop群聊详情的推送详情导出
export let URL_GROUP_SOP_GROUP_PUSH_EXPORT = DOMAIN + '/wxw/groupsop/grouppush/export'
export let URL_GROUP_SOP_GROUP_DATA_EXPORT = DOMAIN + '/wxw/groupsop/groupdata/export'
export let NEW_URL_SOP_GROUP_DATA_EXPORT = DOMAIN  + '/wxw/groupsop/grouppush/export'
export let URL_GROUP_SOP_MANAGER_DATA_EXPORT = DOMAIN + '/wxw/groupsop/managerdata/export'
export let URL_GROUP_SOP_MANAGER_PUSH_EXPORT = DOMAIN + '/wxw/groupsop/managerpush/export'


//好友sop的导出
export let URL_FRIEND_SOP_PUSH_DATA_EXPORT = DOMAIN + '/wxw/friendsop/pushdata/export'

//群聊群发的导出
export let URL_GROUPCHAT_GROUPSEND_EXPIOR = DOMAIN + '/wxw/roommessage/recordExport'
//群聊违规检测
export let URL_GROUPCHAT_ERRORCHECK_EXPIOR = DOMAIN + '/wxw/group/msgcheck/recordlist/export'
export let URL_GROUPCHAT_KEYWORD_EXPIOR = DOMAIN + '/wxw/account/group/keywordreply/ruledata/export'